import React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import MatxTheme from "components/MatxTheme";
import { store } from "./store/store";
import { Provider as ReduxProvider } from "react-redux";
import routes from "routes";
import { useRoutes } from "react-router-dom";
import SnackbarComponent from "components/Snackbar/Snackbar";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import APILoader from "components/Loader/ApiLoader";
import WebSiteModal from "components/Modal/WebSiteModal";
import AsyncAutocomplete from "components/auto-complete/AsyncAutocomplete";
import LocationComponent from "components/Location/Location";
export default function App() {
  // routes configuration
  const content = useRoutes(routes);
  return (
    <ReduxProvider store={store}>


      <MatxTheme>


        <CssBaseline />
        {content}
      </MatxTheme>
      <SnackbarComponent />
      <APILoader />
      <WebSiteModal />

{/* <AsyncAutocomplete /> */}
{/* <LocationComponent /> */}
<LocationComponent />


    </ReduxProvider>
  );
}
